import { render, staticRenderFns } from "./ModalCampus.vue?vue&type=template&id=1547a747&scoped=true&"
import script from "./ModalCampus.vue?vue&type=script&lang=ts&"
export * from "./ModalCampus.vue?vue&type=script&lang=ts&"
import style0 from "./ModalCampus.vue?vue&type=style&index=0&id=1547a747&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1547a747",
  null
  
)

export default component.exports